import React, { useState, useEffect } from "react";

import bannerImg from "../../assets/WEBINAR-RPA-banner.jpg";
import travelImg from "../../assets/travel.png";

import { FaRobot, FaCalendarAlt } from "react-icons/fa";

const responsiveStyles = `
  .th-header {
    display: flex;
    height: 110px;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
  }

  .th-header-left {
    flex: 1.5;
    position: relative;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    padding: 0 20px;
  }

  .th-header-overlay {
    position: absolute;
    inset: 0;
    background: rgba(47,183,164,0.7);
  }

  .th-header-badge {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(0,0,0,0.15);
    padding: 14px 22px;
    border-radius: 6px;
    color: #fff;
    width: 520px;
    max-width: 100%;
  }

  .th-header-icon-box {
    width: 36px;
    height: 36px;
    background: #1f7f73;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .th-header-right {
    flex: 1;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    min-width: 0;
  }

  .th-header-right-deco-right {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg,#2fb7a4 30%,#2f6f9f 60%,#2f4a7f);
    clip-path: polygon(100% 0, 100% 100%, 40% 100%);
  }

  .th-header-title {
    display: flex;
    align-items: center;
    gap: 12px;
    z-index: 1;
  }

  .th-header-title h2 {
    margin: 0;
    font-size: 30px;
    font-weight: 600;
    color: #243b64;
  }

  .th-main {
    display: flex;
    padding: 60px 80px;
    gap: 60px;
    align-items: center;
  }

  .th-image-wrap {
    flex: 1;
  }

  .th-image-wrap img {
    width: 100%;
    max-width: 650px;
    display: block;
  }

  .th-accordion {
    flex: 1.2;
  }

  .th-accordion-item {
    margin-bottom: 18px;
  }

  .th-accordion-header {
    background: linear-gradient(90deg,#2fb7a4 0%,#2f6f9f 60%,#2f4a7f);
    color: #f4f7fb;
    padding: 8px 24px;
    cursor: pointer;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .th-accordion-arrow {
    font-size: 22px;
    flex-shrink: 0;
    margin-left: 12px;
  }

  .th-accordion-body {
    padding: 20px;
    color: #555;
  }

  /* ── Tablet: 768px – 1024px ── */
  @media (max-width: 1024px) {
    .th-main {
      padding: 40px 40px;
      gap: 40px;
    }

    .th-header-badge {
      width: auto;
      font-size: 14px;
      padding: 10px 16px;
    }

    .th-header-title h2 {
      font-size: 24px;
    }
  }

  /* ── Mobile: ≤ 767px ── */
  @media (max-width: 767px) {
    .th-header {
      flex-direction: column;
      height: auto;
    }

    .th-header-left {
      flex: none;
      padding: 16px;
      min-height: 80px;
    }

    .th-header-badge {
      width: 100%;
      font-size: 13px;
      padding: 10px 14px;
      gap: 8px;
    }

    .th-header-right {
      flex: none;
      padding: 16px;
      min-height: 70px;
    }

    .th-header-right-deco-right {
      width: 50px;
    }

    .th-header-title h2 {
      font-size: 20px;
    }

    .th-main {
      flex-direction: column;
      padding: 30px 20px;
      gap: 30px;
    }

    .th-image-wrap {
      width: 100%;
    }

    .th-image-wrap img {
      max-width: 100%;
    }

    .th-accordion {
      width: 100%;
    }

    .th-accordion-header {
      padding: 10px 16px;
      font-size: 14px;
    }

    .th-accordion-body {
      padding: 16px;
      font-size: 14px;
    }
  }

  /* ── Very small phones: ≤ 400px ── */
  @media (max-width: 400px) {
    .th-header-badge {
      font-size: 12px;
      padding: 8px 10px;
    }

    .th-header-title h2 {
      font-size: 17px;
    }

    .th-accordion-header {
      font-size: 13px;
      padding: 8px 12px;
    }

    .th-accordion-body {
      padding: 14px;
      font-size: 13px;
    }
  }
`;

function TravelHospitalityPage() {
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    const styleId = "th-responsive-styles";
    if (!document.getElementById(styleId)) {
      const tag = document.createElement("style");
      tag.id = styleId;
      tag.innerHTML = responsiveStyles;
      document.head.appendChild(tag);
    }
    return () => {
      const existing = document.getElementById(styleId);
      if (existing) existing.remove();
    };
  }, []);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  const data = [
    {
      title: "1.Booking and Booking Extensions",
      content:
        "Bot manage hotel reservations, monitor occupancy, and administer necessary changes."
    },
    {
      title: "2.Chatbots For Updating Travellers",
      content:
        "Deploy chatbot solutions in the airline sector / for travel portals to keep the travelers updated about flight schedules and booking status as well as enable them to ask queries."
    },
    {
      title: "3.Hotel Price Comparison",
      content:
        "Comparation of the prices of different hotels and B&B lodgings across diverse tiers and different cities"
    },
    {
      title: "4.Customer Relationship Management",
      content:
        "RPA helps to update customer profiles with the updated information."
    },
    {
      title: "5.Billing and Settlements",
      content:
        "Bot reads the mails coming from the vendors and dealers and auto-downloads the bill attachments."
    },
    {
      title: "6.Cancellation And Issue Resolution",
      content:
        "Accelerate ticket cancellations and quicker resolution of related issues."
    }
  ];

  return (
    <div>

      {/* ===== HEADER ===== */}
      <div className="th-header">
        {/* LEFT */}
        <div
          className="th-header-left"
          style={{ backgroundImage: `url(${bannerImg})` }}
        >
          <div className="th-header-overlay" />

          <div className="th-header-badge">
            <div className="th-header-icon-box">
              <FaRobot style={{ color: "#fff", fontSize: "18px" }} />
            </div>

            <span>Robotic process automation - Use Cases</span>

            <span style={{ marginLeft: "auto" }}>›</span>
          </div>
        </div>

        {/* RIGHT */}
        <div className="th-header-right">
          <div className="th-header-right-deco-right" />

          <div className="th-header-title">
            <FaCalendarAlt
              style={{
                fontSize: "32px",
                color: "#2fb7a4"
              }}
            />

            <h2>Travel & Hospitality</h2>
          </div>
        </div>
      </div>

      {/* ===== MAIN SECTION ===== */}
      <div className="th-main">
        {/* IMAGE */}
        <div className="th-image-wrap">
          <img src={travelImg} alt="" />
        </div>

        {/* ACCORDION */}
        <div className="th-accordion">
          {data.map((item, i) => (
            <div key={i} className="th-accordion-item">
              <div
                className="th-accordion-header"
                onClick={() => toggle(i)}
              >
                {item.title}
                <span className="th-accordion-arrow">
                  {openIndex === i ? "↑" : "⌄"}
                </span>
              </div>

              {openIndex === i && (
                <div className="th-accordion-body">{item.content}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default TravelHospitalityPage;
